/*
 *  ************************************************************************
 *  *  © [2015 - 2021] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect, useRef } from "react";
import { PropTypes } from "prop-types";

export const StickyComponent = (props) => {
  const stickyRef = useRef(null);
  const options = {
    threshold: 1.0,
  };

  const selectClass = props.targetClassName || "";

  const makeSticky = entries => {
    const targetElement = global && global.document.querySelector(`.${selectClass}`);
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        targetElement.classList.remove("sticky-layer");
      } else {
        targetElement.classList.add("sticky-layer");
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(makeSticky, options);
    if (stickyRef.current) {
      observer.observe(stickyRef.current);
    }
    return () => {
      if (stickyRef.current) {
        observer.unobserve(stickyRef.current);
      }
    };
  }, []);

  return <div ref={stickyRef} />;
};

StickyComponent.propTypes = {
  targetClassName: PropTypes.string
};
